const tabsBlocks = document.querySelectorAll('.block-navigation-link-tabs');

const toggleTab = (e) => {
	e.preventDefault();

	const tabsBlock = e.currentTarget.closest('.block-navigation-link-tabs');

	if (!tabsBlock) {
		return;
	}

	const tabButtonWrapper = e.currentTarget.parentElement;
	const isAlreadyActive = tabButtonWrapper.classList.contains('active');

	const activeTabs = tabsBlock.querySelectorAll(
		'.block-navigation-link-tabs-tab > .wp-block-button.active'
	);

	activeTabs.forEach((activeTab) => {
		if (activeTab !== tabButtonWrapper) {
			activeTab.classList.remove('active');

			const activeTabButton = activeTab.querySelector(
				'.wp-block-button__link'
			);

			if (activeTabButton) {
				activeTabButton.setAttribute('aria-expanded', 'false');
			}
		}
	});

	if (isAlreadyActive && window.innerWidth < 1200) {
		tabButtonWrapper.classList.remove('active');
		e.currentTarget.setAttribute('aria-expanded', 'false');

		return;
	}

	tabButtonWrapper.classList.add('active');
	e.currentTarget.setAttribute('aria-expanded', 'true');
};

if (tabsBlocks.length) {
	tabsBlocks.forEach((tabsBlock) => {
		const tabs = tabsBlock.querySelectorAll(
			'.block-navigation-link-tabs-tab'
		);

		tabs.forEach((tab, index) => {
			const tabButton = tab.querySelector(
				'.block-navigation-link-tabs-tab > .wp-block-button .wp-block-button__link'
			);

			if (!tabButton) {
				return;
			}

			tabButton.addEventListener('click', toggleTab);

			tabButton.setAttribute(
				'aria-expanded',
				0 === index ? 'true' : 'false'
			);

			if (0 === index) {
				tabButton.parentElement.classList.add('active');
			}
		});
	});
}
